// extracted by mini-css-extract-plugin
module.exports = {"inputbox":"Staff_inputbox__7r0VG"};